import * as Types from '../constants/Types';
import EmailTemplate from './../models/EmailTemplate';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    isFetched: false,
    emailTemplate: [],
    allEmailTemplates: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        emailTemplate: new EmailTemplate(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.EMAIL_TEMPLATE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.EMAIL_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                emailTemplates: action.emailTemplates,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
                ...action,
            };
        case Types.EMAIL_TEMPLATE_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.EMAIL_TEMPLATE_ALL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                allEmailTemplates: action.emailTemplates,
            };
        case Types.EMAIL_TEMPLATE_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true, detail: initialState.detail };
        case Types.EMAIL_TEMPLATE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetchingDetail: false,
                detail: { emailTemplate: action.emailTemplate, }
            };
        case Types.EMAIL_TEMPLATE_DETAIL_CREATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.EMAIL_TEMPLATE_DETAIL_DELETE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.EMAIL_TEMPLATE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };

        case Types.EMAIL_TEMPLATE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.EMAIL_TEMPLATE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.EMAIL_TEMPLATE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.EMAIL_TEMPLATE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.EMAIL_TEMPLATE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.EMAIL_TEMPLATE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.EMAIL_TEMPLATE_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false, isFetched: true };
        default:
            return state;
    }
}
